export enum IresaActionEnumV2 {
    SAVE_QUOTE = "SaveQuote",
    GET_QUOTE = "GetQuote",
    CREATE_BOOKING = "CreateBooking",
}

